import { EmbedSessionImpression, NetworkEmbedSessionImpression } from 'embed-sessions/domain/embed-session-impression';
import { Environment } from 'models/environment';
import { apiRequest, getApiHost } from 'shared/api';

interface Params {
  embedSessionId: string;
  stage: string;
  environment: Environment;
}

export const createEmbedSessionImpression = async (params: Params) => {
  const { embedSessionId, stage, environment } = params;

  const response = await apiRequest({
    url: `${getApiHost({ environment })}/v1/embed/embed-sessions/${embedSessionId}/impressions/create`,
    method: 'post',
    body: {
      stage,
    },
  });

  const networkEmbedSessionImpression: NetworkEmbedSessionImpression = await response.json();

  const embedSessionImpression = EmbedSessionImpression.fromNetwork(networkEmbedSessionImpression);

  return embedSessionImpression;
};
